import { Component } from '@angular/core';
import { TermsAndConditionsService } from '../../services/terms-and-conditions/terms-and-conditions.service';
import { ConsentScopesService } from '../../services/config/consent-scopes.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent {
    private _canAccept: boolean;
    private consentScopes: string[];

    get agreeEnabled(): boolean {
        return this._canAccept;
    }

    get canAgree(): boolean {
        return this.termsAndConditionsService.canAgreeToTermsAndConditions;
    }

    get hasAgreed(): boolean {
        return this.termsAndConditionsService.hasAgreedToTermsAndConditions;
    }

    constructor(
        private termsAndConditionsService: TermsAndConditionsService,
        private consentScopesService: ConsentScopesService
    ) {
        this.consentScopes = this.consentScopesService.getConsentScopes();
    }

    async agree(): Promise<void> {
        await this.termsAndConditionsService.agree();
    }

    onScroll(event: any): void {
        const target = event.target;
        this._canAccept = target.scrollHeight - Math.floor(target.scrollTop) === target.clientHeight;
        console.log( this._canAccept);
    }
}
